<template>
  <w-icon-wrapper 
    icon-name='work-confirm-deviation-icon'
    width="24"
    height="22.335"
    viewBox="0 0 24 22.335"
  >
    <g 
      id="Gruppe_22940" 
      data-name="Gruppe 22940"
    >
      <path 
        id="Pfad_54842" 
        data-name="Pfad 54842" 
        d="M19,8.756a1,1,0,0,0-1,1V20.335H2v-18H13.368a1,1,0,0,0,0-2H0v22H20V9.756a1,1,0,0,0-1-1" 
        fill='currentColor'
      />
      <path 
        id="Pfad_54843" 
        data-name="Pfad 54843" 
        d="M5,6.335h5a1,1,0,0,0,0-2H5a1,1,0,0,0,0,2" 
        fill='currentColor'
      />
      <path 
        id="Pfad_54844" 
        data-name="Pfad 54844" 
        d="M5,10.335h7a1,1,0,0,0,0-2H5a1,1,0,1,0,0,2" 
        fill='currentColor'
      />
      <path 
        id="Pfad_54845" 
        data-name="Pfad 54845" 
        d="M16,13.335a1,1,0,0,0-1-1H5a1,1,0,0,0,0,2H15a1,1,0,0,0,1-1" 
        fill='currentColor'
      />
      <path 
        id="Pfad_54846" 
        data-name="Pfad 54846" 
        d="M5,16.335a1,1,0,0,0,0,2h8a1,1,0,0,0,0-2Z" 
        fill='currentColor'
      />
      <path 
        id="Pfad_54847" 
        data-name="Pfad 54847" 
        d="M22.293.293,18.314,4.272,16.66,2.82a1,1,0,1,0-1.32,1.5L18.4,7.013l5.306-5.306A1,1,0,1,0,22.293.293" 
        fill='currentColor'
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconConfirmDeviation' };
</script>
